import { _ as _sfc_main } from "./VaFileUploadList.vue_vue_type_script_lang-f5cf6ed3.mjs";
import { resolveComponent, openBlock, createBlock, normalizeClass, withCtx, createElementBlock, Fragment, renderList, mergeProps, createCommentVNode } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaFileUploadList_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_file_upload_list_item = resolveComponent("va-file-upload-list-item");
  const _component_va_file_upload_gallery_item = resolveComponent("va-file-upload-gallery-item");
  const _component_va_file_upload_single_item = resolveComponent("va-file-upload-single-item");
  const _component_va_list = resolveComponent("va-list");
  return openBlock(), createBlock(_component_va_list, {
    class: normalizeClass(["va-file-upload-list", `va-file-upload-list--${_ctx.type}`]),
    role: _ctx.type !== "single" ? "list" : void 0
  }, {
    default: withCtx(() => [
      _ctx.type === "list" ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.filesList, (file, index) => {
        return openBlock(), createBlock(_component_va_file_upload_list_item, mergeProps({
          key: file.name
        }, _ctx.itemProps, {
          file,
          role: "listitem",
          onRemove: ($event) => _ctx.$emit("remove", index)
        }), null, 16, ["file", "onRemove"]);
      }), 128)) : createCommentVNode("", true),
      _ctx.type === "gallery" ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.filesList, (file, index) => {
        return openBlock(), createBlock(_component_va_file_upload_gallery_item, mergeProps(_ctx.galleryItemProps, {
          key: file.name,
          file,
          role: "listitem",
          onRemove: ($event) => _ctx.$emit("remove", index)
        }), null, 16, ["file", "onRemove"]);
      }), 128)) : createCommentVNode("", true),
      _ctx.type === "single" && _ctx.filesList.length ? (openBlock(), createBlock(_component_va_file_upload_single_item, mergeProps({ key: 2 }, _ctx.singleItemProps, {
        file: _ctx.filesList[_ctx.filesList.length - 1],
        onRemove: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("removeSingle"))
      }), null, 16, ["file"])) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["role", "class"]);
}
const _VaFileUploadList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaFileUploadList as _
};
//# sourceMappingURL=VaFileUploadList-cdd2379b.mjs.map
